





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DurasiJamMenit extends Vue {
  @Prop({ default: null }) value!: number | null;
  @Prop({ default: "Lama" }) label!: string;

  jam: number | null = null;
  menit: number | null = null;

  get total(): number | null {
    if (
      (this.jam === null ||
        this.jam === undefined ||
        (this.jam as any) === "") &&
      (this.menit === null ||
        this.menit === undefined ||
        (this.menit as any) === "")
    ) {
      return null;
    }
    return (Number(this.jam) || 0) * 60 + (Number(this.menit) || 0);
  }

  @Watch("value", { immediate: true })
  onValue(v: number | null) {
    if (v === this.total) return;
    if (v === null || v === undefined || (v as any) === "") {
      this.jam = null;
      this.menit = null;
      return;
    }
    const t = Number(v);
    this.jam = Math.floor(t / 60);
    this.menit = t % 60;
  }

  @Watch("jam")
  onJam() {
    this.emit();
  }

  @Watch("menit")
  onMenit() {
    this.emit();
  }

  emit() {
    this.$emit("input", this.total);
  }
}
